import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { getChildAttendance } from "../../api/parentDashboardApi";

const statusSeverity = {
  present: "success",
  absent: "danger",
  late: "warning",
  excused: "info",
};

const ChildAttendanceTab = ({ child }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  const refresh = async () => {
    if (!child?.id) return;
    try {
      setLoading(true);
      const params = {};
      if (from) params.from = from.toISOString().slice(0, 10);
      if (to) params.to = to.toISOString().slice(0, 10);
      const data = await getChildAttendance(child.id, params);
      if (data?.success) setItems(data.items || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [child?.id]);

  return (
    <div>
      <div className="flex gap-2 mb-3 align-items-end flex-wrap">
        <div>
          <label className="block text-sm">From</label>
          <Calendar value={from} onChange={(e) => setFrom(e.value)} dateFormat="yy-mm-dd" showIcon />
        </div>
        <div>
          <label className="block text-sm">To</label>
          <Calendar value={to} onChange={(e) => setTo(e.value)} dateFormat="yy-mm-dd" showIcon />
        </div>
        <Button label="Apply" icon="pi pi-search" onClick={refresh} />
      </div>
      <DataTable value={items} loading={loading} paginator rows={20} stripedRows emptyMessage="No attendance records.">
        <Column
          field="date"
          header="Date"
          body={(row) => new Date(row.date).toLocaleDateString()}
          sortable
        />
        <Column field="grade.name" header="Grade" />
        <Column field="subject.name" header="Subject" />
        <Column
          field="status"
          header="Status"
          body={(row) => <Tag value={row.status} severity={statusSeverity[row.status] || "info"} />}
        />
      </DataTable>
    </div>
  );
};

export default ChildAttendanceTab;
